module.exports = __webpack_public_path__ + "img/sale-badge-3.6b8c622d.png";